<template>
  <div id="picking_main">

    <div id="picking_header" class="fixed-top d-flex align-items-center">
      <img class="float-end back" @click="funcChangeItem(false)" src="@/assets/picking_left.jpeg">
      <label class="float-start label-number">No.{{number}}</label>
      <label class="float-end label-tasks">{{onTasks}}</label>
      <img class="float-end next" @click="funcChangeItem(true)" src="@/assets/picking_right.jpeg">
    </div>

    <div id="camera" v-bind:class="cameraPos">
      <BarcodeReader @inputedBarcode="inputedBarcode"></BarcodeReader>
    </div>

    <div id="footer" class="fixed-bottom d-flex align-items-center">

      <div class="dropdown option_menu d-flex align-items-center">
        <img class="points dropdown-toggle img-fluid" data-bs-toggle="dropdown" aria-expanded="false" src="@/assets/points.jpeg">
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
          <li @click.prevent="funcPositionChanged()" ><a class="dropdown-item" href="#">カメラ表示位置切り替え</a></li>
          <li @click.prevent="funcSkipItem()"><a class="dropdown-item" href="#">目視チェック</a></li>
          <li @click.prevent="funcCopy()"><a class="dropdown-item" href="#">テンプレート コピー</a></li>
          <li @click.prevent="debugShow()"><a class="dropdown-item" href="#">デバッグ用</a></li>
        </ul>
      </div>

      <div id="isbn" class="center-block" @click="funcSkipItem()">
        <img class="barcord img-fluid" src="@/assets/barcord.jpeg">
        <span class="span-isbn10">{{isbn10}}</span>
      </div>

      <img class="closed-sign" @click="clickedClosedSign()" src="@/assets/picking_closed.jpeg">

    </div>

    <div id="info" v-bind:class="infoPos">
      <div class="info-left center-block">
        <div class="div-cm d-flex align-items-center justify-content-center">
          <label v-show="isKeepaImage" class="label-cm">{{onPageCentimeter}}</label>
          <img v-show="isKeepaImage" class="img-arrow" src="@/assets/arrow.png"/>
        </div>
        <div class="div-img d-flex align-items-center justify-content-center">
          <img v-show="isKeepaImage" class="image-size" :src="imagePath"/>
        </div>
      </div>
      <div class="info-right">

        <div class="div-sku d-flex align-items-center justify-content-center flex-column justify-content-evenly">
          <div class="span-sku rounded">{{shelfNumber}}</div>
          <div class="span-count" v-if="onInputCntMsg != ''">{{onInputCntMsg}}</div>
          <div class="same-item-warning" v-show="sameItemWarning">前注文と同一商品です</div>
        </div>
        <div class="div-name d-flex align-items-left">
          <span class="span-name d-flex align-items-left">{{name}}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { ref, defineComponent, toRef, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'
import BarcodeReader from '@/components/barcordReader.vue'
import SoundEffect from '@/js/soundEffect.js'
import { CameraPosition } from '@/const/const'

export default defineComponent({
  props: {
    id: {
      required: true
    },
    sendIndex: {
      required: true
    },
    skuSort: {
      default: false
    },
    position: {
      default: CameraPosition.TOP
    }
  },
  components: {
    BarcodeReader
  },
  setup (props) {
    const router = useRouter()
    const id = toRef(props, 'id')
    const sendIndex = toRef(props, 'sendIndex')
    const checked = ref(false)
    const tasks = ref(0)
    const activeMenu = ref(false)
    const skuSort = toRef(props, 'skuSort')
    const tmpPosition = toRef(props, 'position')
    const position = ref(Number(tmpPosition.value))

    const active = ref(false)

    const name = ref('')
    const number = ref(0)
    const index = ref(0)
    const isbn10 = ref('')
    const isbn13 = ref('')
    const orderId = ref('')
    const shelfNumber = ref('')
    const page = ref(0)
    const imagePath = ref('')

    const itemCnt = ref(1)
    const inputCnt = ref(0)

    const ariaExpanded = ref(false)

    const se1 = ref(new SoundEffect(require('@/assets/barcode1.mp3')))
    const se2 = ref(new SoundEffect(require('@/assets/barcode2.mp3')))

    const cameraPos = ref({ upper_info: true })
    const infoPos = ref({ lower_info: true })

    const prevIsbn13 = ref('')
    const prevIsbn10 = ref('')
    const sameItemWarning = ref(false)
    const debug = ref('')

    onMounted(() => {
      // カメラ位置データ
      // console.log('check position')
      // console.log(tmpPosition.value)
      // console.log(position.value)
      swapCamera(position.value)

      if (typeof (skuSort.value) === 'string') {
        skuSort.value = (skuSort.value === 'true')
      }
      console.log(skuSort.value)
      console.log(typeof (skuSort.value))
      if (id.value) {
        axios.post('/api/barcode/id', { id: id.value, sendIndex: Number(sendIndex.value), skuSort: Number(skuSort.value) })
          .then((response) => {
            const res = response.data
            funcUpdateBarcode(res)
          })
      } else {
        funcToListSite()
      }
    })

    const onTasks = computed(() => {
      return 'のこり' + tasks.value
    })

    const onPageCentimeter = computed(() => {
      const rtn = (Math.floor(page.value / 10) / 10) + 'cm'
      return page.value === 0 ? '' : rtn
    })

    const isKeepaImage = computed(() => {
      return imagePath.value !== ''
    })

    const onInputCntMsg = computed(() => {
      let buf = ''
      if ((itemCnt.value !== 1) && (itemCnt.value !== inputCnt.value)) {
        buf = itemCnt.value + '冊を注文（あと' + (itemCnt.value - inputCnt.value) + '冊）'
      }
      return buf
    })

    const funcPositionChanged = () => {
      position.value = position.value === CameraPosition.TOP ? CameraPosition.BOTTOM : CameraPosition.TOP
      swapCamera(position.value)
    }

    const swapCamera = (pos) => {
      if (pos === CameraPosition.BOTTOM) {
        cameraPos.value = { lower_info: true }
        infoPos.value = { upper_info: true }
      } else {
        cameraPos.value = { upper_info: true }
        infoPos.value = { lower_info: true }
      }
    }

    const funcUpdateBarcode = (res) => {
      if (res.exist) {
        // console.log('update')
        // console.log(res.json)
        imagePath.value = ''
        // console.log(imagePath.value)
        const item = res.json
        id.value = item.id
        name.value = item.name
        number.value = item.number
        index.value = item.index
        isbn10.value = item.isbn
        isbn13.value = toISBN13(item.isbn)
        getKeepaAPI(isbn10.value)
        orderId.value = item.order_id
        shelfNumber.value = item.shelf_number
        checked.value = item.checked
        itemCnt.value = item.item_cnt
        inputCnt.value = 0
        tasks.value = res.count

        // 直前の商品が同じならば警告
        if (isbn13.value === prevIsbn13.value || isbn10.value === prevIsbn10.value) {
          sameItemWarning.value = true
        } else {
          sameItemWarning.value = false
        }
        prevIsbn10.value = isbn10.value
        prevIsbn13.value = isbn13.value
      } else {
        if (res.count === 0) {
          alert('ピッキングが完了しました')
        }
        funcToListSite()
      }
    }

    const funcToListSite = () => {
      // console.log(sendIndex.value)
      router.push({ name: 'BarcodeList', params: { sendIndex: sendIndex.value, skuSort: skuSort.value, position: Number(position.value) } })
    }

    const getKeepaAPI = (asin) => {
      const params = {
        key: '381aasom32kv5tv5o9n40mao3ngbrtuld69fa83amdivur5bj38545i9aa4l83b5',
        asin: asin,
        domain: '5'
      }
      const query = Object.keys(params).map((key) => key + '=' + encodeURIComponent(params[key])).join('&')

      fetch('https://api.keepa.com/product' + '?' + query, {
        method: 'GET',
        mode: 'cors',
        keepalive: true,
        header: {
          Accept: 'application/json',
          'Content-Encoding': 'gzip',
          'Content-Security-Policy': 'upgrade-insecure-requests',
          'Sec-Fetch-Dest': 'document'
        },
        redirect: 'follow'
      }).then(response => { return response.text() })
        .then(res => {
          const keepaRes = JSON.parse(res)
          const keepaData = keepaRes.products[0]
          page.value = keepaData.numberOfPages

          imagePath.value = ''
          if (keepaData.imagesCSV != null) {
            const imagesCsv = keepaData.imagesCSV.split(',')
            if (imagesCsv.length > 0) {
              imagePath.value = 'https://images-na.ssl-images-amazon.com/images/I/' + imagesCsv[0]
              // console.log('image')
              // console.log(imagePath.value)
            }
          }
        })
        .catch(err => {
          // console.log('err')
          imagePath.value = ''
          page.value = 0
          console.log(err)
        })
    }

    const inputedBarcode = (res) => {
      debug.value = res.value
      isbnChecked(res.value)
    }

    const ariaExpandedClicked = () => {
      // console.log('clicked')
      ariaExpanded.value = !ariaExpanded.value
    }

    // バーコード読み取りしたisbnが一致するか
    const isbnChecked = (isbn) => {
      if ((isbn === isbn10.value) || (isbn === isbn13.value)) {
        se1.value.play()
        // console.log('isbnChecked')
        if ((itemCnt.value !== 1) && (itemCnt.value - 1 > inputCnt.value)) {
          inputCnt.value++
        } else {
          itemCnt.value = 1
          inputCnt.value = 0
          checked.value = true
          imagePath.value = ''
          funcStepItem(false, true)
        }
      } else {
        checked.value = false
        se2.value.play()
      }
    }

    const funcStepItem = (skiped, nextStep = true) => {
      console.log('sort')
      console.log(skuSort.value)
      axios.post('/api/barcode/step_id', { id: id.value, skiped: skiped, index: index.value, sendIndex: sendIndex.value, nextStep: true, skuSort: skuSort.value })
        .then((response) => {
          const res = response.data
          funcUpdateBarcode(res)
        })
    }

    const funcSkipItem = () => {
      if (confirm('目視作業確認としてを行い、次の商品へ移動しますか?')) {
        axios.post('/api/barcode/step_id', { id: id.value, skiped: true, index: index.value, sendIndex: sendIndex.value, nextStep: true, skuSort: skuSort.value })
          .then((response) => {
            const res = response.data
            funcUpdateBarcode(res)
          })
      }
    }

    const funcChangeItem = (nextStep) => {
      // console.log(nextStep)
      // console.log(index.value)
      // console.log(sendIndex.value)
      console.log('sort')
      console.log(skuSort.value)
      console.log(typeof (skuSort.value))
      console.log((skuSort.value ? 1 : 0))
      axios.post('/api/barcode/change_id', { index: index.value, sendIndex: sendIndex.value, nextStep: nextStep, skuSort: skuSort.value })
        .then((response) => {
          const res = response.data
          funcUpdateBarcode(res)
        })
    }

    const funcCopy = () => {
      // console.log('copy')
      const buf = '注文番号:' + orderId.value + '\n商品名:' + name.value + '\nSKU:' + shelfNumber.value + '\nASIN:' + isbn10.value
      navigator.clipboard.writeText(buf)
    }

    const clickedClosedSign = () => {
      funcToListSite()
    }

    const toISBN13 = (isbn10) => {
      const src = '978' + String(isbn10).slice(0, 9)
      const sum = src.split('').map(s => parseInt(s)).reduce((p, c, i) => p + ((i % 2 === 0) ? c : c * 3))
      const rem = 10 - sum % 10
      const checkdigit = rem === 10 ? 0 : rem
      return src + checkdigit
    }

    const debugShow = () => {
      alert('直前に読み取ったバーコード:' + debug.value + '\n' + 'アップロードASIN:' + isbn10.value)
    }

    return {
      active,
      name,
      isbn10,
      isbn13,
      number,
      orderId,
      shelfNumber,
      imagePath,
      page,
      clickedClosedSign,
      onTasks,
      onPageCentimeter,
      isKeepaImage,
      funcStepItem,
      funcSkipItem,
      funcChangeItem,
      onInputCntMsg,
      inputedBarcode,
      activeMenu,
      ariaExpanded,
      ariaExpandedClicked,
      funcCopy,
      cameraPos,
      infoPos,
      funcPositionChanged,
      sameItemWarning,
      debugShow
    }
  }
})
</script>
<style lang="scss" scoped>
#picking_main {
  height: 100%;
  width: 100%;
  font-size: medium;

  #picking_header {
    top: 0;
    position: fixed;
    height: 5vh;
    width: 100%;
    background: #47695E;
    color: white;
    font-weight: bold;
    font-size: large;

    img.back {
      object-fit: cover;
      position: absolute;
      left: 2vw;
      height: 90%;
    }
    label.label-number {
      position: absolute;
      left: 15vw;
    }
    label.label-tasks {
      position: absolute;
      right: 15vw;
    }
    img.next {
      object-fit: cover;
      position: absolute;
      right: 2vw;
      height: 90%;
    }
  }

  #footer {
    position: fixed;
    top : 45vh;
    height: 5vh;
    width: 100%;
    color: #47695E;
    font-weight: bold;
    font-size: large;
    background: #e9edeb;

    .option_menu {
      position: absolute;
      height: 100%;
      img.points {
        position: relative;
        left: 0;
        height: 80%;
        object-fit: cover;
        mix-blend-mode: multiply;
      }
    }

    #isbn {
      height: 100%;
      display: block;
      margin-left: auto;
      margin-right: auto;
      img.barcord {
        position: relative;
        margin-right: 2vw;
        height: 100%;
        object-fit: cover;
        mix-blend-mode: multiply;
      }
      span.span-isbn10 {
        bottom: auto;
        left: 0;
        right: 0;
      }
    }

    .closed-sign {
      position: absolute;
      object-fit: cover;
      right: 3vw;
      height: 50%;
      mix-blend-mode: multiply;
    }
  }

  .upper_info {
    position: fixed;
    top : 5vh;
    height: 40vh;
    width: 100%;
  }

  .lower_info {
    display: flex;
    position: fixed;
    top: 50vh;
    height: 40vh;
    width: 100%;
  }

  #info {
    .info-left {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 40vw;
    }
    .info-left div.div-cm {
      position: relative;
      top: 0;
      height: 6vh;
      width: 100%;
    }
    .info-right {
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 60vw;
    }
    img.img-arrow {
      position: relative;
      height: 6vh;
      object-fit: contain;
    }
    .info-left div.div-img {
      position: relative;
      top: 0;
      height: 28vh;
      width: 100%;
    }
    label.label-cm {
      margin-left: 1rem;
      font-weight: bold;
    }
    img.image-size {
      height: 100%;
      object-fit: contain;
    }

    div.div-sku {
      width: 100%;
      height: 11vh;

      .same-item-warning {
        position: relative;
        padding-left: 1vw;
        margin-left: 2vw;
        font-size: small;
        font-weight: bold;
        color: red;
      }

      .span-sku {
        width: 50%;
        margin-top: 2px;
        position: relative;
        padding-left: 1vw;
        padding-right: 1vw;
        margin-left: 2vw;
        font-size: large;
        font-weight: bold;
        background: #47695E;
        color: white;
      }

      .span-count {
        position: relative;
        padding-left: 1vw;
        margin-left: 2vw;
        font-size: small;
        font-weight: bold;
        color: red;
      }
    }

    div.div-name {
      height: 22vh;
      width: 100%;
      overflow-y: scroll;
    }

    span.span-name {
      height: 100%;
      width: 100%;
      margin-top: 1rem;
      margin-left: 1rem;
      font-size: large;
      font-weight: bold;
    }
  }
}

</style>
